import type { GeoJSONPoint, Location, LocationAddress } from "@sitescene/types";

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

/** POST /shadow/locations body (matches createLocationSchema). */
export type CreateLocationRequest = {
	address?: LocationAddress;
	coordinates?: GeoJSONPoint;
	name: string;
	timezone?: string;
};

/** PATCH /shadow/locations/{locationId} body (matches shadowUpdateLocationSchema). */
export type UpdateLocationRequest = {
	address?: LocationAddress;
	coordinates?: GeoJSONPoint;
	name?: string;
	timezone?: string;
};

/**
 * Shadow Realm locations API (org via `X-Shadow-Org` on the client).
 */
export const locationsApi = {
	createLocation: async (body: CreateLocationRequest): Promise<Location> => {
		const response = await apiClient.post<Location>(
			ENDPOINTS.shadow.locations.create,
			body,
		);
		return response.data;
	},

	getLocations: async (options?: {
		includeZonesAndSensors?: boolean;
	}): Promise<Location[]> => {
		const params = new URLSearchParams();
		if (options?.includeZonesAndSensors) {
			params.set("includeZonesAndSensors", "true");
		}

		const query = params.toString();
		const endpoint = query
			? `${ENDPOINTS.shadow.locations.list}?${query}`
			: ENDPOINTS.shadow.locations.list;

		const response = await apiClient.get<Location[]>(endpoint);
		return response.data;
	},

	updateLocation: async (
		locationId: string,
		body: UpdateLocationRequest,
	): Promise<Location> => {
		const response = await apiClient.patch<Location>(
			ENDPOINTS.shadow.locations.update(locationId),
			body,
		);
		return response.data;
	},
};
